module.exports = __webpack_public_path__ + "img/img_32.84d72e61.png";